<script setup lang="ts">
  import { getImage } from '@/shared/lib/media'
  import type { ProcessingOptions } from '@/shared/lib/media/types'

  const { getImageOptions } = defineProps<{
    alt?: string
    getImageOptions: ProcessingOptions
    height?: number
    width?: number
  }>()

  const imageSrc = computed(() => getImage(getImageOptions))
</script>

<template>
  <img
    :src="imageSrc"
    :alt="alt || ''"
    :width="width"
    :height="height"
  />
</template>
